import { BINARY_DECOMPOSITION } from '../../../../shared/featureFlags/flagNames';
import Locator from '../../../../shared/Locator';
import { useIsFeatureEnabled } from '../../../helpers/features';
import type { DependencyConfidenceMap } from '../../../../shared/model-typings/projectdependencyconfidence';

import useGetRevisionDependencyConfidence from './useGetRevisionDependencyConfidence';

/**
 * Helper hook for fetching the confidence of the dependencies of a user's revision.
 * @param parentLocatorStr - The revision locator of the user's revision.
 * @param dependencyLocatorStr - The locator of a dependency of that revision
 * @returns A query for the confidence of the revision's dependencies.
 */
export function useGetDependencyConfidence(
  parentLocatorStr: string,
  dependencyLocatorStr: string,
) {
  const isBinaryScanningEnabled = useIsFeatureEnabled(BINARY_DECOMPOSITION);
  const parentLocator = new Locator(parentLocatorStr);
  const shouldFetch = isBinaryScanningEnabled && parentLocator.fetcher.value === 'binary';
  const { data, isLoading } = useGetRevisionDependencyConfidence(parentLocatorStr, shouldFetch);
  const confidenceMap = data?.confidences ?? {} as DependencyConfidenceMap;
  return {
    confidence: confidenceMap[dependencyLocatorStr] ?? null,
    isLoading,
  };
}
